<template>
  <div class="container account">
    <div class="row mb-45">
      <div class="col-8">
        <h1>Account</h1>
      </div>
      <div v-if="profileLink" class="col-4 text-right">
        <router-link
          :to="profileLink"
          tag="button"
          class="btn btn-primary profile-button"
          style="margin-top: 7px"
        >
          <span class="d-none d-sm-inline-block">View</span>&nbsp;Profile
        </router-link>
      </div>
    </div>

    <div v-if="loading" class="row">
      <div class="col-12 col-lg-8">
        <div class="dashboard-card">
          <Loader />
        </div>
      </div>
    </div>

    <div v-else class="row">
      <counselor-account
        v-if="$store.getters.currentUser.isCounselor"
        :user="user"
      />
      <student-account
        v-if="$store.getters.currentUser.isStudent"
        :user="user"
      />
      <super-admin-account v-if="$store.getters.currentUser.isAdmin" />
    </div>
  </div>
</template>

<script>
import UserClient from '@/api/UserClient';
import SuperAdminAccount from '@/bettermynd-admin/account/SuperAdminAccount.vue';
import Loader from '@/components/Loader.vue';
import CounselorAccount from '@/counselor/account/CounselorAccount.vue';
import StudentAccount from '@/students/account/StudentAccount.vue';

export default {
  name: 'Account',

  components: {
    SuperAdminAccount,
    Loader,
    CounselorAccount,
    StudentAccount
  },

  data() {
    return {
      userClient: new UserClient(this.$http),

      loading: true,
      user: null
    };
  },

  computed: {
    profileLink() {
      const { currentUser } = this.$store.getters;
      if (currentUser.isStudent) {
        return `/profile/`;
      }
      if (currentUser.isCounselor) {
        return `/counselor/profile/${currentUser.counselor_profile.id}`;
      }
      return null;
    }
  },

  async mounted() {
    this.user = await this.userClient.getRemoteUser();

    if (this.user) {
      this.$store.commit('setUser', this.user);
    }

    this.loading = false;
  }
};
</script>
